import React from 'react';

const PartFPage1 = ({ data }) => {
  const groupProject = data?.group_project_work || {};
  const problemBased = data?.problem_based_inquiry || {};
  const classroom = data?.classroom_interactions || {};

  const calculateSectionTotal = (section) => {
    if (!section) return 0;
    return Object.values(section).reduce((sum, val) => sum + (val || 0), 0);
  };

  const renderInput = (value) => (
    <div style={{
      padding: '8px',
      textAlign: 'center',
      fontSize: '12px',
      color: '#333'
    }}>
      {value || 0}
    </div>
  );

  const sections = [
    {
      title: '1. Group Project Work',
      data: groupProject,
      items: [
        { key: 'research_prompt', label: 'Research prompt/question/problem/challenge/planned final output' },
        { key: 'guiding_questions', label: 'Guiding questions' },
        { key: 'stage_1_brainstorming', label: 'Stage 1 (Brainstorming and ideation)' },
        { key: 'stage_2_drafting', label: 'Stage 2 (Drafting, feedback, and revision)' },
        { key: 'stage_3_final_submission', label: 'Stage 3 (Final submission)' }
      ]
    },
    {
      title: '2. Problem-Based Inquiry (Individual Work)',
      data: problemBased,
      items: [
        { key: 'project_prompt', label: 'Project prompt/question/problem/challenge/planned final output' },
        { key: 'hypothesis', label: 'Hypothesis' },
        { key: 'guiding_questions', label: 'Guiding questions' },
        { key: 'evidence_collection', label: 'Evidence collection to support/negate hypothesis' },
        { key: 'analysis_synthesis', label: 'Analysis and synthesis' },
        { key: 'discussions', label: 'Discussions' },
        { key: 'conclusion', label: 'Conclusion' }
      ]
    },
    {
      title: '3. Classroom Interactions',
      data: classroom,
      items: [
        { key: 'classroom_discussion', label: 'Classroom discussion' },
        { key: 'organised_debate', label: 'Organised debate' },
        { key: 'simulation_roleplay', label: 'Simulation/roleplay' },
        { key: 'lab_experiment', label: 'Lab experiment' },
        { key: 'digital_learning', label: 'Digital Learning' }
      ]
    }
  ];

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      margin: '0 auto',
      padding: '20mm',
      backgroundColor: 'white',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #FF8C42 transparent transparent'
      }} />

      <div style={{
        color: '#FF8C42',
        fontSize: '22px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '8px',
        letterSpacing: '2px'
      }}>
        PART F
      </div>

      <div style={{
        color: '#2C5F7E',
        fontSize: '18px',
        fontWeight: 'bold',
        textAlign: 'left',
        marginBottom: '20px'
      }}>
        Number of Hours Spent by the Learner on the Following Activities:
      </div>

      {sections.map((section, sectionIndex) => (
        <React.Fragment key={sectionIndex}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            border: '2px solid #888',
            marginBottom: '5px'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#F4CD8A' }}>
                <th style={{
                  width: '50px',
                  padding: '10px 8px',
                  textAlign: 'left',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  color: '#333',
                  border: '1px solid #888'
                }}>S.No.</th>
                <th colSpan={2} style={{
                  padding: '10px 8px',
                  textAlign: 'left',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  color: '#333',
                  border: '1px solid #888'
                }}>
                  {section.title}
                </th>
                <th style={{
                  width: '160px',
                  padding: '10px 8px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  color: '#333',
                  border: '1px solid #888'
                }}>Number of Hours Spent</th>
              </tr>
            </thead>
            <tbody>
              {section.items.map((item, index) => (
                <tr key={item.key} style={{ backgroundColor: index % 2 === 0 ? '#FFFEF8' : '#FFF9E6' }}>
                  <td style={{ padding: '8px', textAlign: 'center', fontSize: '12px', border: '1px solid #888' }}></td>
                  <td style={{ padding: '8px 6px', fontSize: '12px', border: '1px solid #888', width: '35px', fontWeight: 'bold' }}>
                    {String.fromCharCode(97 + index)})
                  </td>
                  <td style={{ padding: '8px 10px', fontSize: '12px', border: '1px solid #888' }}>
                    {item.label}
                  </td>
                  <td style={{ padding: '0', border: '1px solid #888' }}>
                    {renderInput(section.data[item.key])}
                  </td>
                </tr>
              ))}
              <tr style={{ backgroundColor: '#F4E4B8' }}>
                <td colSpan={3} style={{
                  padding: '10px',
                  textAlign: 'right',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  border: '1px solid #888'
                }}>
                  Total Hours
                </td>
                <td style={{
                  padding: '10px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  border: '1px solid #888'
                }}>
                  {calculateSectionTotal(section.data)}
                </td>
              </tr>
            </tbody>
          </table>
          {sectionIndex < sections.length - 1 && (
            <div style={{
              height: '6px',
              backgroundColor: '#666',
              marginBottom: '5px'
            }} />
          )}
        </React.Fragment>
      ))}

      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '12px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        39
      </div>

      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #FF8C42'
      }} />

      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '50px 50px 0 0',
        borderColor: 'transparent #FFB347 transparent transparent',
        opacity: 0.5
      }} />
    </div>
  );
};

export default PartFPage1;
